import util from '@bmp-vue/core/api/util'

const controller = 'Referenciador'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetAllByAcesso: function (dto) {
    return util.Axios.Get(controller + '/GetAllByAcesso', dto)
  },
  AddRerefencia: function (dto) {
    return util.Axios.Post(controller + '/Add', dto)
  },
  UpdateRerefencia: function (dto) {
    return util.Axios.Post(controller + '/Update', dto)
  },
  RemoveReferencia: function (dto) {
    return util.Axios.Post(controller + '/Delete', dto)
  },
})
